import React from "react";
import { Col, Row } from "react-bootstrap";
import { isRgbColorEnabled, getScaleColors } from "../../../../../../Helpers/RgbColorHelper";

export default function Detail_Textual_10_scale({ item, isSub }) {
  let elementScore = item.normScore ? Math.round(Number(item.normScore)) : Math.round(item.score);

  // Find the hit range to display on the right
  const hitRange = item.scale.ranges.find((range) => range.isHit);

  // Check if RGB color is enabled using helper
  const rgbEnabled = isRgbColorEnabled(item.scale);

  // Get color variations using helper only if RGB is enabled
  const colors = rgbEnabled ? getScaleColors(item.scale) : null;

  // Calculate which scale position (1-10) the score falls into
  // Score is 0-100, so divide by 10 and round up
  const scalePosition = Math.ceil(elementScore / 10) || 1; // Ensure minimum value of 1

  // Generate the 10 scale boxes
  const renderScaleBoxes = () => {
    const boxes = [];
    for (let i = 1; i <= 10; i++) {
      const isActive = i === scalePosition;
      const borderColor = rgbEnabled ? colors.primary : "#4a90e2";

      boxes.push(
        <div
          key={i}
          style={{
            width: "80px",
            height: "60px",
            borderTop: `3px solid ${borderColor}`,
            borderBottom: `3px solid ${borderColor}`,
            borderLeft: i === 1 ? `3px solid ${borderColor}` : "none",
            borderRight: `3px solid ${borderColor}`,
            backgroundColor: isActive ? (rgbEnabled ? colors.primary : "#4a90e2") : "#ffffff",
            color: isActive ? "#ffffff" : rgbEnabled ? colors.dark : "#333333",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "24px",
            fontWeight: "600",
            borderTopLeftRadius: i === 1 ? "8px" : "0",
            borderBottomLeftRadius: i === 1 ? "8px" : "0",
            borderTopRightRadius: i === 10 ? "8px" : "0",
            borderBottomRightRadius: i === 10 ? "8px" : "0",
          }}
        >
          {i}
        </div>
      );
    }
    return boxes;
  };

  return (
    <Row className={"mb-2 mx-0"}>
      <div className="p-3" style={{ border: "1px solid #e0e0e0", borderRadius: "8px", backgroundColor: "#fff" }}>
        {/* Main layout */}
        <Row className="align-items-stretch">
          {/* Left side - Scope name and Item name with ten scale */}
          <Col xs={5}>
            {/* Scope name (only if isSub) */}

            {/* Item name */}
            <div
              style={{
                fontSize: "20px",
                fontWeight: "600",
                color: rgbEnabled ? colors.dark : "#333",
                marginBottom: "5px",
              }}
            >
              {item.name}
              {!item.isSub && item.scopeName && (
                <span
                  style={{
                    fontSize: "14px",
                    fontWeight: "600",
                    color: "#acacacff",
                    textTransform: "uppercase",
                    marginLeft: "8px",
                  }}
                >
                  ({item.scopeName})
                </span>
              )}
            </div>

            {/* Ten scale boxes */}
            <div style={{ display: "flex", flexDirection: "row", marginBottom: "15px" }}>{renderScaleBoxes()}</div>
          </Col>

          {/* Right side - Hit range text */}
          <Col xs={7} className="pe-4">
            {hitRange &&
              (item.scale.isHtml ? <div dangerouslySetInnerHTML={{ __html: hitRange.text }} /> : hitRange.text)}
          </Col>
        </Row>
      </div>
    </Row>
  );
}
